<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none"><path d="m21.7 7.75-7.75 7.75 7.75 7.75-1.55 3.1L9.3 15.5 20.15 4.65l1.55 3.1Z"/></svg>
</template>

<script>
export default {
  name: 'icon-chevron'
}
</script>
